import { Box } from '@mui/material';

import SaveDashboard from '@/assets/icons/SaveDashboard';
import Button from '@/components/Buttons/Button';
import { useSaveApp } from '@/features/Dashboard/drawer/components/AddAppHeader/useSaveApp';
import { useDrawerSteps } from '@/features/Dashboard/drawer/context/DrawerStepsContext';
import type { MarketApp } from '@/features/Dashboard/types';

export const DrawerFooterButtons = ({
  createWidget,
  isValid
}: {
  createWidget: () => MarketApp | undefined;
  isValid: boolean;
}) => {
  const { handleAttemptClose } = useDrawerSteps();
  const { handleSave, isPending } = useSaveApp();

  const disabled = isPending || !isValid;

  return (
    <Box
      sx={{
        minHeight: '96px',
        width: '100%',
        backgroundColor: 'background.default',
        borderTop: '1px solid',
        borderColor: 'info.dark',
        p: 3,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 3,
        '& > *': {
          flex: 1
        }
      }}
    >
      <Button
        disabled={disabled}
        sx={{
          color: 'primary.main',
          borderColor: 'primary.main',
          height: '48px',
          '&.Mui-disabled': {
            opacity: 1,
            borderColor: 'gx.neutral'
          }
        }}
        variant='outlined'
        onClick={() => {
          handleAttemptClose();
        }}
      >
        Discard
      </Button>
      <Button
        disabled={disabled}
        startIcon={<SaveDashboard sx={{ fontSize: '24px !important' }} />}
        sx={{
          height: '48px',
          '&.Mui-disabled': {
            opacity: 1,
            backgroundColor: 'gx.neutral',
            borderColor: 'gx.neutral'
          }
        }}
        onClick={() => {
          handleSave(createWidget());
        }}
      >
        Save
      </Button>
    </Box>
  );
};
